<div class="page-header border-bottom">
    <h3>Recent Notifications</h3>
</div>
<div>
    <table class="table table-responsive-lg">
        <thead>
            <tr>
                <th>Date</th>
                <th>URL</th>
                <th>Message</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let notification of notifications">
                <td>{{ notification.dateTimeStamp | date: dateFormat }}</td>
                <td>{{ notification.url }}</td>
                <td>{{ notification.message }}</td>
            </tr>
        </tbody>
    </table>
</div>